<template>
  <div class="main">
    <div class="cards__single main__profile">
      <div class="cards__header">
        <h1>{{ $vuetify.lang.t('$vuetify.main.profile.label') }}</h1>


        <router-link :to="{name:'profile', params: {edit:true}}">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.8934 3.38037C16.5059 2.769 17.3317 2.41924 18.1969 2.40476C19.0622 2.39029 19.8993 2.71224 20.5318 3.30278C21.1644 3.89333 21.543 4.70635 21.5879 5.57054C21.6328 6.43474 21.3405 7.28263 20.7726 7.93557L20.6166 8.10357L9.08941 19.6308C8.8437 19.8761 8.5477 20.0653 8.22181 20.1852L8.02381 20.2488L3.15781 21.576C3.06355 21.6019 2.96438 21.6045 2.86891 21.5834C2.77345 21.5623 2.68458 21.5182 2.61006 21.4549C2.53553 21.3916 2.4776 21.311 2.44131 21.2203C2.40502 21.1295 2.39146 21.0312 2.40181 20.934L2.42101 20.838L3.74821 15.9732C3.83941 15.6372 4.00261 15.3252 4.22581 15.0612L4.36621 14.9076L15.8934 3.38037ZM14.8614 6.11037L5.21461 15.756C5.10439 15.8664 5.01676 15.9972 4.95661 16.1412L4.90621 16.2888L3.85381 20.1408L7.70821 19.0908C7.80861 19.0634 7.90502 19.023 7.99501 18.9708L8.12341 18.8844L8.24101 18.7824L17.8866 9.13437L14.8614 6.11037ZM19.7682 4.22877C19.3908 3.85113 18.8859 3.6282 18.3526 3.60378C17.8193 3.57936 17.2961 3.7552 16.8858 4.09677L16.7418 4.22877L15.7098 5.26077L18.7338 8.28717L19.7682 7.25517C20.1459 6.8778 20.3688 6.37289 20.3932 5.83957C20.4176 5.30626 20.2418 4.78308 19.9002 4.37277L19.7682 4.22877Z"
              fill="#ADB2B7"/>
          </svg>
        </router-link>
      </div>
      <div class="profile__content">
        <div class="profile__info">
          <div class="profile__photo avatar">
            <router-link v-if="type === 'profile'" to="/profile">
              <img
                class="info__profile-photo"
                v-if="user.photo_path"
                :src="$media_url + user.photo_path"
                alt="profile-photo"
              />
            </router-link>
            <div v-if="type === 'client'">
              <img
                class="info__profile-photo"
                v-if="user.logo_path"
                :src="$media_url + user.logo_path"
                alt="profile-photo"
              />
            </div>
          </div>
          <div class="profile__description" v-if="type==='profile'">
            <router-link to="/profile">
              <div class="profile__name">{{ user.name }} {{ user.lastname }}</div>
            </router-link>
            <div class="profile__position" v-if="user.position">
              {{
                user.position.name[$vuetify.lang.current] ? user.position.name[$vuetify.lang.current] : (user.position.name['eng'] ? user.position.name['eng'] : user.position.name['fin'])
              }}
            </div>
          </div>
          <div class="profile__description" v-if="type==='client'">
            <router-link to="/client-profile">
              <div class="profile__name">{{ user.name }}</div>
            </router-link>
          </div>
          <div class="profile__photo sign" v-if="type !== 'client'">
            <img
              v-if="user.sign_path"
              :src="$media_url + user.sign_path"
              alt="sign-photo"
            />
          </div>
        </div>
        <div class="profile__contact">
          <ul>
            <li v-if="type === 'profile' && user.citizenship">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9ZM16.8 9C16.8 10.9778 15.7985 13.0015 14.4 14.4C13.0015 15.7985 10.9778 16.8 9 16.8C7.02224 16.8 4.99849 15.7985 3.6 14.4C2.20151 13.0015 1.2 10.9778 1.2 9C1.2 7.02224 2.20151 4.99849 3.6 3.6C4.99849 2.20151 7.02224 1.2 9 1.2C10.9778 1.2 13.0015 2.20151 14.4 3.6C15.7985 4.99849 16.8 7.02224 16.8 9Z"
                      fill="#2C1521"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M5.14286 9.00001C5.14286 13.6512 6.67646 17.4857 9 17.4857C11.3235 17.4857 12.8571 13.6512 12.8571 9.00001C12.8571 4.34881 11.3235 0.514291 9 0.514291C6.67646 0.514291 5.14286 4.34881 5.14286 9.00001ZM11.6603 9.00001C11.6603 12.8695 10.0851 16.29 9 16.29C7.91486 16.29 6.34028 12.8695 6.34028 9.00001C6.34028 5.13052 7.91486 1.71001 9 1.71001C10.0851 1.71001 11.6603 5.13052 11.6603 9.00001Z"
                      fill="#2C1521"/>
                <path
                  d="M2.41908 4.3375L3.45383 3.19373C3.55668 3.2863 3.6688 3.37887 3.78811 3.46835C5.09543 4.44755 7.1824 5.39 9.46068 5.39C11.4057 5.39 13.217 4.61315 14.5326 3.86127C14.8494 3.68024 15.1312 3.48378 15.375 3.27498L16.3768 4.44858C16.0579 4.72115 15.6969 4.97315 15.2989 5.19944C13.7395 6.09224 11.6639 6.59418 9.46068 6.59418C6.86663 6.59418 4.45669 5.89681 2.8624 4.70264C2.7091 4.5878 2.56117 4.46596 2.41908 4.3375Z"
                  fill="#2C1521"/>
                <path
                  d="M2.41908 13.679L3.45383 14.8227C3.55668 14.7291 3.6688 14.6376 3.78811 14.5481C5.09543 13.5689 7.1824 12.61 9.46068 12.61C11.4057 12.61 13.217 13.4033 14.5326 14.1552C14.8494 14.3362 15.1312 14.5327 15.375 14.7415L16.3768 13.5679C16.0417 13.2845 15.6808 13.0331 15.2989 12.817C13.7395 11.9242 11.6639 11.4223 9.46068 11.4223C6.86663 11.4223 4.45669 12.1196 2.8624 13.3138C2.7091 13.4287 2.56117 13.5505 2.41908 13.679Z"
                  fill="#2C1521"/>
                <path d="M1 9.6V8.4H17V9.6H1Z" fill="#2C1521"/>
              </svg>
              <span>{{ user.citizenship }}</span>
            </li>
            <li>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 3.99982C16.163 3.99982 16.7989 4.26321 17.2678 4.73205C17.7366 5.20089 18 5.83678 18 6.49982V14.4998C18 15.1629 17.7366 15.7987 17.2678 16.2676C16.7989 16.7364 16.163 16.9998 15.5 16.9998H4.5C3.83696 16.9998 3.20107 16.7364 2.73223 16.2676C2.26339 15.7987 2 15.1629 2 14.4998V6.49982C2 5.83678 2.26339 5.20089 2.73223 4.73205C3.20107 4.26321 3.83696 3.99982 4.5 3.99982H15.5ZM17 7.96082L10.254 11.9308C10.1902 11.9683 10.1189 11.9911 10.0453 11.9977C9.9716 12.0042 9.8974 11.9944 9.828 11.9688L9.746 11.9308L3 7.96282V14.4998C3 14.8976 3.15804 15.2792 3.43934 15.5605C3.72064 15.8418 4.10218 15.9998 4.5 15.9998H15.5C15.8978 15.9998 16.2794 15.8418 16.5607 15.5605C16.842 15.2792 17 14.8976 17 14.4998V7.96082ZM15.5 4.99982H4.5C4.10218 4.99982 3.72064 5.15785 3.43934 5.43916C3.15804 5.72046 3 6.10199 3 6.49982V6.80182L10 10.9198L17 6.79982V6.49982C17 6.10199 16.842 5.72046 16.5607 5.43916C16.2794 5.15785 15.8978 4.99982 15.5 4.99982Z"
                  fill="#2C1521"
                />
              </svg>
              <span v-if="type === 'profile'">{{ user.auth_user_id.email }}</span>
              <span v-else>{{ user.email }}</span>
            </li>
            <li v-if="user.phone">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 14.0003C8.86739 14.0003 8.74021 14.053 8.64645 14.1468C8.55268 14.2405 8.5 14.3677 8.5 14.5003C8.5 14.6329 8.55268 14.7601 8.64645 14.8539C8.74021 14.9476 8.86739 15.0003 9 15.0003H11C11.1326 15.0003 11.2598 14.9476 11.3536 14.8539C11.4473 14.7601 11.5 14.6329 11.5 14.5003C11.5 14.3677 11.4473 14.2405 11.3536 14.1468C11.2598 14.053 11.1326 14.0003 11 14.0003H9Z"
                  fill="#2C1521"
                />
                <path
                  d="M7 2.00031C6.46957 2.00031 5.96086 2.21102 5.58579 2.58609C5.21071 2.96116 5 3.46987 5 4.00031V16.0003C5 16.5307 5.21071 17.0394 5.58579 17.4145C5.96086 17.7896 6.46957 18.0003 7 18.0003H13C13.5304 18.0003 14.0391 17.7896 14.4142 17.4145C14.7893 17.0394 15 16.5307 15 16.0003V4.00031C15 3.46987 14.7893 2.96116 14.4142 2.58609C14.0391 2.21102 13.5304 2.00031 13 2.00031H7ZM6 4.00031C6 3.73509 6.10536 3.48073 6.29289 3.2932C6.48043 3.10566 6.73478 3.00031 7 3.00031H13C13.2652 3.00031 13.5196 3.10566 13.7071 3.2932C13.8946 3.48073 14 3.73509 14 4.00031V16.0003C14 16.2655 13.8946 16.5199 13.7071 16.7074C13.5196 16.8949 13.2652 17.0003 13 17.0003H7C6.73478 17.0003 6.48043 16.8949 6.29289 16.7074C6.10536 16.5199 6 16.2655 6 16.0003V4.00031Z"
                  fill="#2C1521"
                />
              </svg>
              <span>{{ user.phone }}</span>
            </li>
            <li v-if="type==='profile' && user.tax_number">
              <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.50059 7.80054C5.31493 7.80054 5.13689 7.87429 5.00561 8.00556C4.87434 8.13684 4.80059 8.31489 4.80059 8.50054C4.80059 8.68619 4.87434 8.86424 5.00561 8.99551C5.13689 9.12679 5.31493 9.20054 5.50059 9.20054H12.5006C12.6862 9.20054 12.8643 9.12679 12.9956 8.99551C13.1268 8.86424 13.2006 8.68619 13.2006 8.50054C13.2006 8.31489 13.1268 8.13684 12.9956 8.00556C12.8643 7.87429 12.6862 7.80054 12.5006 7.80054H5.50059ZM4.80059 12.7005C4.80059 12.5149 4.87434 12.3368 5.00561 12.2056C5.13689 12.0743 5.31493 12.0005 5.50059 12.0005H12.0386C11.8846 12.4387 11.8006 12.9105 11.8006 13.4005H5.50059C5.31493 13.4005 5.13689 13.3268 5.00561 13.1955C4.87434 13.0642 4.80059 12.8862 4.80059 12.7005ZM16.0006 4.30054V9.20054C16.4906 9.20054 16.9624 9.28454 17.4006 9.43994V4.30054C17.4006 3.74358 17.1793 3.20944 16.7855 2.81561C16.3917 2.42179 15.8575 2.20054 15.3006 2.20054H14.6006V1.50054C14.6006 1.31489 14.5268 1.13684 14.3956 1.00556C14.2643 0.874287 14.0862 0.800537 13.9006 0.800537C13.7149 0.800537 13.5369 0.874287 13.4056 1.00556C13.2743 1.13684 13.2006 1.31489 13.2006 1.50054V2.20054H9.70059V1.50054C9.70059 1.31489 9.62684 1.13684 9.49556 1.00556C9.36429 0.874287 9.18624 0.800537 9.00059 0.800537C8.81493 0.800537 8.63689 0.874287 8.50561 1.00556C8.37434 1.13684 8.30059 1.31489 8.30059 1.50054V2.20054H4.80059V1.50054C4.80059 1.31489 4.72684 1.13684 4.59556 1.00556C4.46429 0.874287 4.28624 0.800537 4.10059 0.800537C3.91493 0.800537 3.73689 0.874287 3.60561 1.00556C3.47434 1.13684 3.40059 1.31489 3.40059 1.50054V2.20054H2.70059C2.14363 2.20054 1.60949 2.42179 1.21566 2.81561C0.821835 3.20944 0.600586 3.74358 0.600586 4.30054V21.1005C0.600586 21.6575 0.821835 22.1916 1.21566 22.5855C1.60949 22.9793 2.14363 23.2005 2.70059 23.2005H10.0506C9.75247 22.7681 9.51462 22.2971 9.34359 21.8005H2.70059C2.51493 21.8005 2.33689 21.7268 2.20561 21.5955C2.07434 21.4642 2.00059 21.2862 2.00059 21.1005V4.30054C2.00059 4.11489 2.07434 3.93684 2.20561 3.80556C2.33689 3.67429 2.51493 3.60054 2.70059 3.60054H15.3006C15.4862 3.60054 15.6643 3.67429 15.7956 3.80556C15.9268 3.93684 16.0006 4.11489 16.0006 4.30054ZM5.50059 16.2005C5.31493 16.2005 5.13689 16.2743 5.00561 16.4056C4.87434 16.5368 4.80059 16.7149 4.80059 16.9005C4.80059 17.0862 4.87434 17.2642 5.00561 17.3955C5.13689 17.5268 5.31493 17.6005 5.50059 17.6005H8.30059C8.48624 17.6005 8.66429 17.5268 8.79556 17.3955C8.92684 17.2642 9.00059 17.0862 9.00059 16.9005C9.00059 16.7149 8.92684 16.5368 8.79556 16.4056C8.66429 16.2743 8.48624 16.2005 8.30059 16.2005H5.50059ZM18.8006 13.4005C18.8126 13.0256 18.7492 12.652 18.6141 12.3021C18.4789 11.9521 18.2749 11.6328 18.014 11.3633C17.753 11.0937 17.4406 10.8793 17.0952 10.7329C16.7499 10.5864 16.3786 10.5108 16.0034 10.5106C15.6283 10.5104 15.2569 10.5856 14.9114 10.7318C14.5659 10.8779 14.2532 11.092 13.9921 11.3613C13.7309 11.6306 13.5265 11.9496 13.391 12.2994C13.2555 12.6493 13.1917 13.0228 13.2034 13.3977C13.226 14.1247 13.5306 14.8143 14.0527 15.3206C14.5747 15.8269 15.2734 16.1103 16.0006 16.1106C16.7279 16.111 17.4268 15.8284 17.9494 15.3225C18.472 14.8167 18.7772 14.1274 18.8006 13.4005ZM10.4006 19.7005C10.4006 19.9413 10.4146 20.1751 10.4454 20.4005C10.5836 21.5669 11.1775 22.6313 12.0974 23.3615C13.1348 24.1945 14.5264 24.6005 16.0006 24.6005C17.4748 24.6005 18.8664 24.1945 19.9038 23.3615C20.9566 22.5145 21.6006 21.2629 21.6006 19.7005C21.6006 19.1436 21.3793 18.6094 20.9855 18.2156C20.5917 17.8218 20.0575 17.6005 19.5006 17.6005H12.5006C11.9436 17.6005 11.4095 17.8218 11.0157 18.2156C10.6218 18.6094 10.4006 19.1436 10.4006 19.7005Z"
                  fill="#557EAE"/>
              </svg>
              <span>{{ user.tax_number }}</span>
            </li>
            <li v-if="type==='profile' && user.social_code_fin">
              <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.99922 0.800537C8.51401 0.800537 7.08962 1.39054 6.03942 2.44074C4.98922 3.49094 4.39922 4.91533 4.39922 6.40054C4.39922 7.88575 4.98922 9.31013 6.03942 10.3603C7.08962 11.4105 8.51401 12.0005 9.99922 12.0005C11.4844 12.0005 12.9088 11.4105 13.959 10.3603C15.0092 9.31013 15.5992 7.88575 15.5992 6.40054C15.5992 4.91533 15.0092 3.49094 13.959 2.44074C12.9088 1.39054 11.4844 0.800537 9.99922 0.800537ZM5.79922 6.40054C5.79922 5.28663 6.24172 4.21834 7.02937 3.43069C7.81702 2.64304 8.88531 2.20054 9.99922 2.20054C11.1131 2.20054 12.1814 2.64304 12.9691 3.43069C13.7567 4.21834 14.1992 5.28663 14.1992 6.40054C14.1992 7.51445 13.7567 8.58273 12.9691 9.37039C12.1814 10.158 11.1131 10.6005 9.99922 10.6005C8.88531 10.6005 7.81702 10.158 7.02937 9.37039C6.24172 8.58273 5.79922 7.51445 5.79922 6.40054Z"
                  fill="#557EAE"/>
                <path
                  d="M3.01182 13.4005C2.64311 13.3991 2.27774 13.4704 1.93665 13.6104C1.59557 13.7505 1.28548 13.9565 1.02418 14.2166C0.762878 14.4767 0.555497 14.7859 0.413932 15.1263C0.272366 15.4668 0.1994 15.8318 0.199219 16.2005C0.199219 18.5679 1.36542 20.3529 3.18822 21.5163C4.98302 22.6601 7.40222 23.2005 9.99922 23.2005C12.5962 23.2005 15.0154 22.6601 16.8102 21.5163C18.633 20.3543 19.7992 18.5665 19.7992 16.2005C19.7992 15.4579 19.5042 14.7457 18.9791 14.2206C18.454 13.6955 17.7418 13.4005 16.9992 13.4005H3.01182ZM1.59922 16.2005C1.59922 15.4263 2.22642 14.8005 3.01182 14.8005H16.9992C17.3705 14.8005 17.7266 14.948 17.9892 15.2106C18.2517 15.4731 18.3992 15.8292 18.3992 16.2005C18.3992 18.0331 17.5284 19.3981 16.057 20.3347C14.559 21.2909 12.4282 21.8005 9.99922 21.8005C7.57022 21.8005 5.43942 21.2909 3.94142 20.3347C2.47142 19.3967 1.59922 18.0345 1.59922 16.2005Z"
                  fill="#557EAE"/>
              </svg>
              <span>{{ user.social_code_fin }}</span>
            </li>
            <li v-if="type==='profile' && user.address_fin">
              <svg width="18" height="19" viewBox="0 0 18 19" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.79721 0.865346C8.12759 0.568506 8.55606 0.404297 9.00021 0.404297C9.44436 0.404297 9.87282 0.568506 10.2032 0.865346L16.8032 6.79575C16.9909 6.9645 17.1409 7.17082 17.2437 7.40133C17.3464 7.63184 17.3996 7.88138 17.3996 8.13375V16.5997C17.3996 17.0771 17.21 17.535 16.8724 17.8725C16.5348 18.2101 16.077 18.3997 15.5996 18.3997H12.5996C12.1222 18.3997 11.6644 18.2101 11.3268 17.8725C10.9893 17.535 10.7996 17.0771 10.7996 16.5997V12.3997C10.7996 12.2406 10.7364 12.088 10.6239 11.9755C10.5114 11.863 10.3587 11.7997 10.1996 11.7997H7.79961C7.64048 11.7997 7.48787 11.863 7.37535 11.9755C7.26282 12.088 7.19961 12.2406 7.19961 12.3997V16.5997C7.19961 17.0771 7.00997 17.535 6.6724 17.8725C6.33484 18.2101 5.877 18.3997 5.39961 18.3997H2.39961C1.92222 18.3997 1.46438 18.2101 1.12682 17.8725C0.789252 17.535 0.599609 17.0771 0.599609 16.5997V8.13375C0.599609 7.62375 0.815609 7.13775 1.19721 6.79575L7.79721 0.865346ZM9.40041 1.75815C9.29031 1.65931 9.14757 1.60464 8.99961 1.60464C8.85165 1.60464 8.70891 1.65931 8.59881 1.75815L1.99881 7.68855C1.93629 7.74467 1.88625 7.8133 1.85193 7.88999C1.81762 7.96668 1.79979 8.04973 1.79961 8.13375V16.5997C1.79961 16.7589 1.86282 16.9115 1.97535 17.024C2.08787 17.1365 2.24048 17.1997 2.39961 17.1997H5.39961C5.55874 17.1997 5.71135 17.1365 5.82387 17.024C5.9364 16.9115 5.99961 16.7589 5.99961 16.5997V12.3997C5.99961 11.9224 6.18925 11.4645 6.52682 11.127C6.86438 10.7894 7.32222 10.5997 7.79961 10.5997H10.1996C10.677 10.5997 11.1348 10.7894 11.4724 11.127C11.81 11.4645 11.9996 11.9224 11.9996 12.3997V16.5997C11.9996 16.7589 12.0628 16.9115 12.1753 17.024C12.2879 17.1365 12.4405 17.1997 12.5996 17.1997H15.5996C15.7587 17.1997 15.9114 17.1365 16.0239 17.024C16.1364 16.9115 16.1996 16.7589 16.1996 16.5997V8.13375C16.1994 8.04973 16.1816 7.96668 16.1473 7.88999C16.113 7.8133 16.0629 7.74467 16.0004 7.68855L9.40041 1.75815Z"
                  fill="#2C1521"/>
              </svg>
              {{
                (user.address_fin.street + ' ' + user.address_fin.house +
                  (user.address_fin.entrance ? (' ' + user.address_fin.entrance + ' ') : '') +
                  (user.address_fin.flat ? (' ' + user.address_fin.flat + ', ') : ', ') +
                  user.address_fin.index + ' ' + user.address_fin.city + ', ')
              }} Suomi
            </li>


          </ul>
        </div>
      </div>
    </div>
    <div class="cards__single close main__news" v-if="type === 'profile' && news.length">
      <div class="accordion-btn btn-icon btn-action" @click="toggleClose">
        <svg data-v-91462a68="" width="19" height="10" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path data-v-91462a68="" d="M1 0.5L4.5 4.5L8 0.5" stroke="#2C1521" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </div>
      <div class="cards__header">
        <div class="cards__header-left">
          <h2 class="h1">{{ $vuetify.lang.t('$vuetify.main.news.label') }}</h2>
          <!--              <div class="header__new">+5</div>-->
        </div>
        <router-link class="cards__header-right link-all" to="/news">
          <span>{{ $vuetify.lang.t('$vuetify.main.see_all') }}</span>
          <svg
            width="5"
            height="9"
            viewBox="0 0 5 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 8L4.5 4.5L0.5 1"
              stroke="#557EAE"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </router-link>
      </div>
      <div class="news__content">
        <div class="news__item" v-for="item in news" :key="item.id">
          <div class="unread-dot" v-if="unreadNews.includes(item.id)"></div>
          <router-link class="link-not-like" :to="'/news/' + item.id">{{ item.title }}</router-link>
          <!--          v-html="item.text.replace(/(\<(\/?[^>]+)>)/g, '').substr(0, 67) + '...'"-->
        </div>
      </div>
    </div>
    <div class="cards__single" v-if="todo.length">
      <div class="accordion-btn btn-icon btn-action" @click="toggleClose">
        <svg data-v-91462a68="" width="19" height="10" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path data-v-91462a68="" d="M1 0.5L4.5 4.5L8 0.5" stroke="#2C1521" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </div>
      <h2 class="h1">{{ $vuetify.lang.t('$vuetify.menu.todo') }}</h2>
      <div v-for="(item, date) in todo" :key="date">
        <div class="accordion__title">
          <div class="accordion__title-text h2 flex">
            {{ new Date(item.date).toLocaleDateString('ru-Ru') }}
            <template v-if="item.date_end">
              - {{ new Date(item.date_end).toLocaleDateString('ru-Ru') }}
            </template>
          </div>
        </div>
        <div v-for="(data, obj) in item.objects" :key="obj">
          <div class="accordion__content">
            <div class="bolder ">
              <div>{{ obj }}</div>
              <a target="_blank"
                 :href="'https://www.google.com/maps/search/?api=1&query='+data.object.street + '+' + data.object.house + '+' + data.object.city">
                {{ data.object.street }} {{ data.object.house }}{{
                  data.object.entrance ? data.object.entrance +
                    ' ' : ''
                }}
                {{ data.object.flat ? data.object.flat + ', ' : ', ' }}{{ data.object.index }}
                {{ data.object.city }}, {{ data.object.country }}
              </a>
            </div>
            <template v-for="task in data.data">
              <div :key="task.id.toString() + obj">
                <div>{{ task.time.substring(0, 5) }} -
                  <template v-for="profile in task.user_profiles">
                    <span class="bolder" :key="task.id +'_' + profile.id">
                  {{ profile.name }} {{ profile.lastname }},
                    </span>
                  </template>
                </div>
                <div v-html="task.comment"></div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="cards__single close main__unread" v-if="unreadObjects.length">
      <div class="accordion-btn btn-icon btn-action" @click="toggleClose">
        <svg data-v-91462a68="" width="19" height="10" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path data-v-91462a68="" d="M1 0.5L4.5 4.5L8 0.5" stroke="#2C1521" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </div>
      <div class="cards__header">
        <h2 class="h1">{{ $vuetify.lang.t('$vuetify.newComments') }}</h2>
        <button class="btn btn-primary" @click="readComments">{{ $vuetify.lang.t('$vuetify.markRead') }}</button>
      </div>
      <div class="unread__content flex flex-column align-start">
        <router-link v-for="com in unreadObjects" :key="com.id" :to="'objects/'+com.object.id+'?tab=3'">
          {{ com.object.name }}
        </router-link>
      </div>
    </div>
    <div class="cards__single close" v-if="timingChanges.length">
      <div class="accordion-btn btn-icon btn-action" @click="toggleClose">
        <svg data-v-91462a68="" width="19" height="10" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path data-v-91462a68="" d="M1 0.5L4.5 4.5L8 0.5" stroke="#2C1521" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </div>
      <div class="cards__header">
        <h2 class="h1">{{ $vuetify.lang.t('$vuetify.timingChanges') }}</h2>
      </div>
      <table class="history" style="width: 100%">
        <thead>
        <tr>
          <th> {{ $vuetify.lang.t('$vuetify.date') }}</th>
          <th> {{ $vuetify.lang.t('$vuetify.author') }}</th>
          <th> {{ $vuetify.lang.t('$vuetify.beforeChanges') }}</th>
          <th> {{ $vuetify.lang.t('$vuetify.afterChanges') }}</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="line in timingChanges">
          <tr :key="line.id" class="rows__single">
            <td>{{ new Date(line.datetime).toLocaleDateString('ru-Ru') }}
              {{ new Date(line.datetime).toLocaleTimeString('ru-Ru').substring(0, 5) }}
            </td>
            <td>{{ line.author.name }} {{ line.author.lastname }}</td>
            <td>
              {{ $vuetify.lang.t('$vuetify.wages.rate') }} {{ line.old.options.rate }}€ <br>
              {{ line.old.time_start.substring(0, 5) }}-{{ line.old.time_end.substring(0, 5) }}

            </td>
            <td>
              {{ $vuetify.lang.t('$vuetify.wages.rate') }} {{ line.changes.options.rate }}€ <br>
              {{ line.changes.time_start.substring(0, 5) }}-{{ line.changes.time_end.substring(0, 5) }}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <div class="cards__single close" v-if="comments.length">
      <div class="accordion-btn btn-icon btn-action" @click="toggleClose">
        <svg data-v-91462a68="" width="19" height="10" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path data-v-91462a68="" d="M1 0.5L4.5 4.5L8 0.5" stroke="#2C1521" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </div>
      <div class="cards__header">
        <h2 class="h1">{{ $vuetify.lang.t('$vuetify.comments') }}</h2>
      </div>
      <div class="unread__content flex flex-column align-start">
        <div v-for="com in comments" :key="com.id" class="flex">
          <router-link :to="'objects/'+com.objects_id.id+'?tab=3'">
            {{ com.objects_id.name }}
          </router-link>
          -
          <pre v-if="com.text" v-html="com.text"></pre>
          <div v-else>
            {{ $vuetify.lang.t("$vuetify.uploadedFiles") }}
          </div>
        </div>
      </div>
    </div>
    <div class="cards__single close" v-if="Object.keys(expired).length">
      <div class="accordion-btn btn-icon btn-action" @click="toggleClose">
        <svg data-v-91462a68="" width="19" height="10" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path data-v-91462a68="" d="M1 0.5L4.5 4.5L8 0.5" stroke="#2C1521" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </div>
      <div class="cards__header">
        <h2 class="h1">{{ $vuetify.lang.t('$vuetify.expiredDocuments') }}</h2>
      </div>
      <div class="unread__content flex flex-column align-start">
        <div v-for="(item, id) in expired" :key="id">
          <div>
            <span class="bolder">{{ item.name }} {{ item.lastname }}: </span>
            <template v-for="(card, index) in item.cards">
              <span :key="card.id +''+card.card.name">
                {{
                  card.card.name[$vuetify.lang.current] ? card.card.name[$vuetify.lang.current] : card.card.name['eng'] ? card.card.name['eng'] : card.card.name['fin']
                }}<span v-if="index < item.cards.length - 1">, </span>
              </span>
            </template>

          </div>
        </div>
      </div>
    </div>
    <div class="cards__single close" v-if="absence.length">
      <div class="accordion-btn btn-icon btn-action" @click="toggleClose">
        <svg data-v-91462a68="" width="19" height="10" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path data-v-91462a68="" d="M1 0.5L4.5 4.5L8 0.5" stroke="#2C1521" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </div>
      <div class="cards__header">
        <h2 class="h1">{{ $vuetify.lang.t('$vuetify.upcomingAbsence') }}</h2>
      </div>
      <div class="unread__content flex flex-column align-start">
        <div v-for="item in absence" :key="item.id" class="flex">
          <span class="bolder">{{ item.user_profile.name }} {{ item.user_profile.lastname }}</span> –
          {{ new Date(item.date_start).toLocaleDateString() }}-{{ new Date(item.date_end).toLocaleDateString() }}
        </div>
      </div>
    </div>
    <div class="cards__single main__calendar" v-if="events.length">
      <div class="accordion-btn btn-icon btn-action" @click="toggleClose">
        <svg data-v-91462a68="" width="19" height="10" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path data-v-91462a68="" d="M1 0.5L4.5 4.5L8 0.5" stroke="#2C1521" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </div>
      <div class="cards__header">
        <h2 class="h1">{{ $vuetify.lang.t('$vuetify.main.calendar.label') }}</h2>
        <router-link class="link-all" to="/calendar">
          <span>{{ $vuetify.lang.t('$vuetify.main.see_all') }}</span>
          <svg
            width="5"
            height="9"
            viewBox="0 0 5 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 8L4.5 4.5L0.5 1"
              stroke="#557EAE"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </router-link>
      </div>
      <div class="cards__content">
        <div v-for="event in events" :key="event.id" class="calendar__event"
             :style="'border-left: ' + event.color + ' solid 6px'">
          <h2 class="event__header">{{ event.name }}</h2>
          <div class="event__time">
            {{ new Date(event.start).toLocaleDateString('ru-Ru') }}
            <span v-if="!event.allDay">{{ event.start.substr(11, 5) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="cards widgets main__widgets">
      <div
        v-for="(widget, i) in widgetsUsers"
        :key="widget.id"
        class="cards__single widgets__single note"
      >
        <div class="widgets__header">
          <h2 class="h1" v-if="!widget.settings.name">
            {{ $vuetify.lang.t("$vuetify.widgets." + widget.widget.type + ".label") }}
            <span v-if="widget.widget.type === 'note'">{{ i + 1 }}</span>
          </h2>
          <h2 class="h1" v-else>{{ widget.settings.name }}</h2>
          <div class="header__buttons">
            <button class="btn-icon"
                    @click="
                newWidget = widget;
                addWidgetUserForm = true;
              "
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.8934 3.38037C16.5059 2.769 17.3317 2.41924 18.1969 2.40476C19.0622 2.39029 19.8993 2.71224 20.5318 3.30278C21.1644 3.89333 21.543 4.70635 21.5879 5.57054C21.6328 6.43474 21.3405 7.28263 20.7726 7.93557L20.6166 8.10357L9.08941 19.6308C8.8437 19.8761 8.5477 20.0653 8.22181 20.1852L8.02381 20.2488L3.15781 21.576C3.06355 21.6019 2.96438 21.6045 2.86891 21.5834C2.77345 21.5623 2.68458 21.5182 2.61006 21.4549C2.53553 21.3916 2.4776 21.311 2.44131 21.2203C2.40502 21.1295 2.39146 21.0312 2.40181 20.934L2.42101 20.838L3.74821 15.9732C3.83941 15.6372 4.00261 15.3252 4.22581 15.0612L4.36621 14.9076L15.8934 3.38037ZM14.8614 6.11037L5.21461 15.756C5.10439 15.8664 5.01676 15.9972 4.95661 16.1412L4.90621 16.2888L3.85381 20.1408L7.70821 19.0908C7.80861 19.0634 7.90502 19.023 7.99501 18.9708L8.12341 18.8844L8.24101 18.7824L17.8866 9.13437L14.8614 6.11037ZM19.7682 4.22877C19.3908 3.85113 18.8859 3.6282 18.3526 3.60378C17.8193 3.57936 17.2961 3.7552 16.8858 4.09677L16.7418 4.22877L15.7098 5.26077L18.7338 8.28717L19.7682 7.25517C20.1459 6.8778 20.3688 6.37289 20.3932 5.83957C20.4176 5.30626 20.2418 4.78308 19.9002 4.37277L19.7682 4.22877Z"
                  fill="#ADB2B7"
                />
              </svg>
            </button>
            <button class="btn-icon" @click="openWidgetConfirm(widget.id)">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.25 5.99976C17.25 5.40302 17.0129 4.83072 16.591 4.40877C16.169 3.98681 15.5967 3.74976 15 3.74976C14.4033 3.74976 13.831 3.98681 13.409 4.40877C12.9871 4.83072 12.75 5.40302 12.75 5.99976H11.25C11.25 5.00519 11.6451 4.05137 12.3483 3.34811C13.0516 2.64484 14.0054 2.24976 15 2.24976C15.9946 2.24976 16.9484 2.64484 17.6517 3.34811C18.3549 4.05137 18.75 5.00519 18.75 5.99976H25.5C25.6989 5.99976 25.8897 6.07877 26.0303 6.21943C26.171 6.36008 26.25 6.55084 26.25 6.74976C26.25 6.94867 26.171 7.13943 26.0303 7.28009C25.8897 7.42074 25.6989 7.49976 25.5 7.49976H24.669L22.725 24.3448C22.6404 25.0758 22.2899 25.7503 21.7404 26.2399C21.1908 26.7294 20.4805 26.9999 19.7445 26.9998H10.2555C9.51952 26.9999 8.80918 26.7294 8.25963 26.2399C7.71007 25.7503 7.35964 25.0758 7.275 24.3448L5.3295 7.49976H4.5C4.32446 7.49981 4.15446 7.4383 4.01961 7.32592C3.88476 7.21354 3.7936 7.05743 3.762 6.88476L3.75 6.74976C3.75 6.55084 3.82902 6.36008 3.96967 6.21943C4.11032 6.07877 4.30109 5.99976 4.5 5.99976H17.25ZM23.157 7.49976H6.8415L8.7645 24.1723C8.80683 24.5379 8.98216 24.8753 9.25709 25.1201C9.53203 25.3648 9.88738 25.5 10.2555 25.4998H19.7445C20.1124 25.4996 20.4673 25.3643 20.742 25.1196C21.0166 24.8748 21.1917 24.5377 21.234 24.1723L23.157 7.49976ZM12.75 11.2498C13.1175 11.2498 13.425 11.4823 13.488 11.7883L13.5 11.9068V21.0943C13.5 21.4558 13.164 21.7498 12.75 21.7498C12.3825 21.7498 12.075 21.5173 12.012 21.2113L12 21.0928V11.9083C12 11.5453 12.336 11.2513 12.75 11.2513V11.2498ZM17.25 11.2498C17.6175 11.2498 17.925 11.4823 17.988 11.7883L18 11.9068V21.0943C18 21.4558 17.664 21.7498 17.25 21.7498C16.8825 21.7498 16.575 21.5173 16.512 21.2113L16.5 21.0928V11.9083C16.5 11.5453 16.836 11.2513 17.25 11.2513V11.2498Z"
                  fill="#557EAE"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          v-if="widget.widget.type === 'note'"
          :style="'background-color:' + widget.settings.color"
          class="note__content"
        >
          <pre>{{ widget.settings.text }}</pre>
        </div>
      </div>
      <div
        class="cards__single widgets__single widgets__new"
        @click="addWidgetForm = true"
      >
        <svg
          width="136"
          height="136"
          viewBox="0 0 136 136"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="68"
            cy="68"
            r="67"
            stroke="#557EAE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="15 20"
          />
          <path
            d="M68 41.5V89.5M92 65.5L44 65.5"
            stroke="#557EAE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="new__title">{{ $vuetify.lang.t('$vuetify.widgets.new') }}</div>
      </div>
    </div>

    <v-dialog max-width="500px" v-model="addWidgetForm">
      <div class="modal">
        <div class="h1">{{ $vuetify.lang.t("$vuetify.widgets.selectWidget") }}</div>
        <div class="widgets__select"
             v-for="item in widgets"
             :key="item.id"
             @click="openAddWidgetUser(item)"
        >
          {{ $vuetify.lang.t("$vuetify.widgets." + item.type + ".label") }}
        </div>
      </div>
    </v-dialog>

    <v-dialog max-width="500px" v-model="addWidgetUserForm">
      <div class="modal modal-big">
        <div class="h1">{{ $vuetify.lang.t('$vuetify.widgets.note.label') }}</div>
        <v-form ref="form" @submit.prevent="">
          <v-text-field v-model="newWidget.settings.name" :label="$vuetify.lang.t('$vuetify.name2')"
                        outlined></v-text-field>
          <v-textarea
            v-if="newWidget.settings.text !== undefined"
            v-model="newWidget.settings.text"
            filled
            :background-color="newWidget.settings.color"
            outlined
          ></v-textarea>

          <v-menu
            ref="menuColor"
            v-model="menuColor"
            :close-on-content-click="false"
            transition="scale-transition"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newWidget.settings.color"
                :label="$vuetify.lang.t('$vuetify.color')"
                v-bind="attrs"
                v-on="on"
                outlined
                readonly
              ></v-text-field>
            </template>
            <v-color-picker
              v-if="newWidget.settings.color !== undefined"
              v-model="newWidget.settings.color"
            ></v-color-picker>
          </v-menu>

          <div class="btn-group">
            <button
              class="btn btn-secondary"
              @click="
                addWidgetUserForm = false;
                addWidgetForm = false;
              "
            >
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="addWidgetUser">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <ConfirmModal v-model="confirmModal" @confirm="deleteWidget"></ConfirmModal>
  </div>
</template>

<script>
import ConfirmModal from "@/components/confirmModal";

export default {
  name: "MainView",
  components: {ConfirmModal},
  data() {
    return {
      type: "",
      user: {
        auth_user_id: {},
        position: {},
      },
      widgetsUsers: [],

      widgets: [],
      news: [],
      unreadNews: [],
      events: [],
      todo: [],
      unreadObjects: [],
      comments: [],
      timingChanges: [],
      expired: {},
      absence: [],

      newWidget: {
        widget: "",
        settings: "",
      },
      widgetToDelete: 0,
      confirmModal: false,
      addWidgetForm: false,
      addWidgetUserTitle: "",
      addWidgetUserForm: false,
      hex: "#FFFFFF",
      menuColor: false,
    };
  },

  created() {
    if (
      !(
        localStorage.getItem("auth_token") ||
        sessionStorage.getItem("auth_token")
      )
    ) {
      this.$router.push({name: "AuthLayout"});
    } else {
      this.loadUser();
    }
  },

  methods: {
    toggleClose(event) {
      const target = event.target;
      const card = target.closest('.cards__single');

      if (card.classList.contains('close')) {
        card.classList.remove('close');
      } else {
        card.classList.add('close');
      }
    },
    loadUser() {
      this.$axios({
        url: this.$hostname + "time-tracking/user",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.user = response.data.data.data;
          this.type = response.data.data.type;
          if (this.type === "profile") {
            this.loadNews()
            this.loadChanges()
            this.loadLastComments()
            this.loadTodo()
            this.loadExpired()
            this.loadAbsence()
          }
          this.loadWidgetsUsers();
          this.loadWidgets();
          this.loadEvents()
        })
        .catch((response) => {
          if (response.response.status === 404) {
            this.user = response.response.data.errors
            this.$router.push({name: "SignUpLayout", params: {id: this.user.id},})
          } else {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          }
        });
    },
    loadWidgets() {
      this.$axios({
        url: this.$hostname + "time-tracking/widgets",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.widgets = response.data.data.data;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadWidgetsUsers() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/widgets",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.widgetsUsers = response.data.data.data;
          this.widgetsUsers.forEach((widget) => {
            widget.settings = JSON.parse(widget.settings);
          });
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadNews() {
      this.$axios({
        url: this.$hostname + "time-tracking/news",
        method: "GET",
        params: {
          limit: 5,
          arch: true,
        },
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.news = response.data.data.data;
        this.unreadNews = response.data.data.unread;
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      });
    },
    loadEvents() {
      this.$axios({
        url: this.$hostname + "time-tracking/calendar",
        method: 'GET',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Token ' + (localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')),
        },
        params: {
          limit: 3
        },
      }).then((response) => {
        this.events = response.data.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      });
    },
    loadChanges() {
      this.$axios({
        url: this.$hostname + "time-tracking/changes",
        type: "GET",
        headers: {
          "Authorization": "Token " + (localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token'))
        },
        params: {
          table: 'TimeReport',
        }
      }).then((response) => {
        this.unreadObjects = response.data.data.unread_objects
        if (response.data.data.history) {
          this.timingChanges = response.data.data.history
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadLastComments() {
      this.$axios({
        url: this.$hostname + "time-tracking/last-comments",
        type: "GET",
        headers: {
          "Authorization": "Token " + (localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token'))
        },
      }).then((response) => {
        this.comments = response.data.data.comments;

        this.parseCommentFiles(this.comments);

        this.comments.forEach(com => {
          this.parseCommentLinks(com);
        });
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
      })
    },
    loadTodo: function () {
      this.$axios({
        url: this.$hostname + "time-tracking/todo/my",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        if (response.data.data.data) {
          this.todo = response.data.data.data;
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },
    loadExpired: function () {
      this.$axios({
        url: this.$hostname + "time-tracking/expired",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        if (response.data.data.data) {
          this.expired = response.data.data.data;
          console.log(this.expired.length)
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },
    loadAbsence: function () {
      this.$axios({
        url: this.$hostname + "time-tracking/upcoming-absence",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        if (response.data.data.data) {
          this.absence = response.data.data.data;
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },

    addWidgetUser() {
      let type = "POST";
      if (this.newWidget.id) {
        type = "PUT";
      }
      if (this.newWidget.settings.last_save !== undefined) {
        this.newWidget.settings.last_save = new Date().toISOString();
      }
      this.newWidget.settings = JSON.stringify(this.newWidget.settings);
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/widgets",
        method: type,
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newWidget,
      })
        .then(() => {
          this.loadWidgetsUsers();
          this.addWidgetForm = false;
          this.addWidgetUserForm = false;
          this.newWidget = {
            widget: "",
            settings: "",
          };
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    deleteWidget() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/widgets",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {id: this.widgetToDelete},
      })
        .then(() => {
          this.loadWidgetsUsers();
          this.confirmModal = false;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    openAddWidgetUser(type) {
      this.newWidget = {
        widget: type.id,
        settings: type.default_settings,
      };
      if (type.default_settings) {
        this.addWidgetUserTitle = this.$vuetify.lang.t(
          "$vuetify.widgets." + type.type + ".label"
        );
        this.addWidgetUserForm = true;
      } else {
        this.addWidgetUser();
      }
    },
    openWidgetConfirm(id) {
      this.widgetToDelete = id;
      this.confirmModal = true;
    },

    readComments() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/comments-read/all",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
      }).then(() => {
        this.loadChanges()
        this.$emit("changes")
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      });
    },

    parseCommentLinks(comment) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      comment.display_text = comment.text.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
      });
    },
  },
};
</script>

<style scoped></style>
